import React, { ReactNode, memo, useEffect, useState } from "react";
import { isNil, isEmpty } from "ramda";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import Container from "@mui/material/Container";
import { Grid, Paper } from "@mui/material";
import * as Yup from "yup";
import Layout from "../../Layout";
import { ApplicationState } from "../../../store";
import {
  fetchRequest as fetchProcessor,
  saveRequest,
} from "../../../store/processor/actions";
import Alert from "@mui/lab/Alert";
import {
  Processor,
  Data,
  ProcessorState,
} from "../../../store/processor/types";
import { getNewProcessor } from "../../../repo/processor";
import pageStyles from "../../pageStyles";
import { withFormik } from "formik";
import useSession from "../../../effects/useSession";
import PageHeading from "../../../common/pageHeading/PageHeading";
import ProcessorEditForm from "../processorEditForm/ProcessorEditForm";
import { toast } from "react-toastify";
import { fetchRequest as fetchCardType } from "../../../store/cardType/actions";

const schema = Yup.object({
  attributes: Yup.object({
    Name: Yup.string().required("Processor is required"),
    Host: Yup.string().required("Host is required"),
    Port: Yup.string().required("Port is required"),
  }),
});

const CREATE = "CREATE";
const UPDATE = "UPDATE";

const SaveError: React.FC<{ children: ReactNode }> = ({ children }) => (
  <Alert severity="error">{children}</Alert>
);

function ProcessorEdit() {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = pageStyles();

  const { id } = useParams<{ id: string }>();
  const mode = id ? UPDATE : CREATE;

  const session = useSession();
  // const [showError, setShowError] = useState(false);

  useEffect(() => {
    !isNil(id) && dispatch(fetchProcessor(id));
    dispatch(fetchCardType(null));
  }, []);

  const processorState = useSelector(
    (state: ApplicationState) => state.processor
  );

  const getById = (processor: ProcessorState, id: string | undefined) => {
    return (
      id &&
      processor &&
      processor.data &&
      processor.data.data?.find((x) => x.id === id)
    );
  };

  const userGroup = getById(processorState, id) as Data;

  const InnerForm = () => {
    return <ProcessorEditForm />;
  };

  const EditForm = withFormik<Data, Data>({
    mapPropsToValues: (data) => (!isEmpty(data) ? data : getNewProcessor()),
    handleSubmit: (values) => {
      const callback = (err: string | null, data: Processor | null) => {
        if (err) {
          let errText = `An error occurred while saving: ${err}`;
          console.log(err);
          toast.error(errText, {
            closeOnClick: true,
          });
        } else {
          if (mode === CREATE) {
            history.goBack();
          } else {
            toast.success("Saved successfully!", {
              closeOnClick: true,
            });
          }
        }
      };
      dispatch(saveRequest(values, callback));
    },
    validationSchema: schema,
  })(InnerForm);

  const headingText = () => {
    return mode === CREATE ? "New Processor" : "Edit Processor";
  };

  return (
    <Layout sessionData={session}>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Paper>
                <PageHeading heading={headingText()} />
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                <EditForm {...userGroup} />
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
}
export default memo(ProcessorEdit);
